import axios from '../../plugins/axios.js';

export default{
  async getFilters() {
    return await axios.get('/api/SubscriptionFilterType/');
  },
  async getFilterByID(filterID) {
    return await axios.get(`/api/SubscriptionFilterType/${filterID}`);
  },
  async createFilter(model) {
    return await axios.post('/api/SubscriptionFilterType/', model);
  },
  async updateFilterPenaltyValue(filterData) {
    return await axios.put('/api/SubscriptionFilterType/UpdateFilterPenaltyValue/', filterData);
  },
  async getSubscriptionFilterDropdowns() {
    return await axios.get('/api/SubscriptionFilterType/GetSubscriptionFilterDropdowns');
  }
};
